var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":"是否禁用"}},[_c('el-switch',{model:{value:(_vm.data.disabled),callback:function ($$v) {_vm.$set(_vm.data, "disabled", $$v)},expression:"data.disabled"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }